import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export const TitleText = styled(Text)(({ theme }) => ({
    marginBottom: theme.spacing.xxxSmall,
}));

export const TextWrapper = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.xxxSmall,
    marginBottom: theme.spacing.medium,
}));
